import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import ExecCard from './ExecCard'; 
import axios from '../axiosConfig';
import '../assets/styles/ExecBySector.css';

const ExecBySector = () => {
  const testUser =
  {
    "id": 1,
    "user_id": 7,
    "bio": "Software engineer with over 5 years of experience in full-stack development. Passionate about AI and cloud computing.",
    "public_profile": 1,
    "education": "B.Sc. in Computer Science, University of Exampleville",
    "experience": "3 years as a full-stack developer at TechCorp, 2 years as a cloud architect at Cloudify Ltd.",
    "certificate_path": null,
    "photo_path": null,
    "rating": 4,
    "available": 1,
    "created_at": null,
    "updated_at": null,
    "user": {
      "id": 7,
      "first_name": "Alexandre",
      "last_name": "Martel",
      "email": "alexandre.martel2201@gmail.com",
      "sectors": [
        {
          "id": 1,
          "name": "IT",
          "created_at": null,
          "updated_at": null,
          "pivot": {
            "user_id": 7,
            "sector_id": 1
          }
        },
        {
          "id": 4,
          "name": "Building",
          "created_at": null,
          "updated_at": null,
          "pivot": {
            "user_id": 7,
            "sector_id": 4
          }
        }
      ],
      "practices": [
        {
          "id": 1,
          "name": "Marketing",
          "created_at": null,
          "updated_at": null,
          "pivot": {
            "user_id": 7,
            "practice_id": 1
          }
        },
        {
          "id": 2,
          "name": "Human Ressources",
          "created_at": null,
          "updated_at": null,
          "pivot": {
            "user_id": 7,
            "practice_id": 2
          }
        }
      ]
    }
  }

  const testSector = [
    {
    "id": 1,
    "name": "IT",
    },
    { "id": 2,
    "name": "Marketing",
    },
  ]
  
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState(null);
  const [selectedExecPartners, setSelectedExecPartners] = useState([testUser]); 
  const [isLoading, setIsLoading] = useState(false);

  // Fetch sectors when the component loads
  useEffect(() => {
    const fetchSectors = async () => {
      try {
        const response = await axios.get('/api/sectors');
        const data = response.data.data;
        setSectors(response.data.data);
        if (data.length > 0) setSelectedSector(data[0].id); 
      } catch (error) {
        console.error('Error fetching sectors:', error);
      }
    };
    fetchSectors();
  }, []);

  
  useEffect(() => {
    const fetchExecPartners = async () => {
      if (!selectedSector) return;

      setIsLoading(true); 
      try {
        const response = await axios.get('/api/exec-partners/by-sectors', {
          params: { id: selectedSector },
        });
        
        const data = response.data.data;
        setSelectedExecPartners(data);
      } catch (error) {
        console.error('Error fetching exec-partners :', error);
      } finally {
        setIsLoading(false); 
      }
    };
    fetchExecPartners();
  }, [selectedSector]);

  return (
    <div>
      <Container>
        {/* Tab menu */}
        <Nav variant="tabs" className="justify-content-center nav-tabs" defaultActiveKey="All">
          {sectors.map((sector) => (
            <Nav.Item key={sector.id}>
              <Nav.Link eventKey={sector.name} onClick={() => setSelectedSector(sector.id)}>
                {sector.name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        
        <Row className="mt-4">
          {/* Loader or Exec Partners list */}
          {isLoading ? (
            <p className="loader">Loading ...</p>
          ) : selectedExecPartners.length > 0 ? (
            selectedExecPartners.map((partner) => (
              <Col md={12} key={partner.id}>
                <ExecCard
                  key={partner.id}
                  first_name={partner.user.first_name}
                  last_name={partner.user.last_name}
                  email={partner.user.email}
                  bio={partner.bio}
                  experience={partner.experience}
                  education={partner.education}
                  rating={partner.rating}
                  available={partner.available}
                  sectors={partner.user.sectors.map(s => s.name).join(', ')} 
                  practices={partner.user.practices.map(p => p.name).join(', ')}
                />
              </Col>
            ))
          ) : (
            <p>No exec partner found for the selected area.</p>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default ExecBySector;